
module Meevo.Plugins.Client {
    import IClientFormService = Meevo.Plugins.DocsAndForms.IClientFormService;

    export function clientFormLocation(): any {
        return (services: IClientFormService[], locationId: number) => {
            if (!locationId) {
                return services;
            }

            return services
                .filter((form) => locationId === form.locationId)
        }
    }

    angular.module('meevo.plugins.client')
        .filter('clientFormLocation', clientFormLocation);
}
